module.exports = __webpack_public_path__ + "static/media/successTrans.13d09511.gif";